import React, { useState, useEffect } from 'react';
import './App.css';

// Components
import Background from './components/Background';
import Navigation from './components/Navigation';
import MainContent from './components/MainContent';

const App: React.FC = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    // Handle URL hash changes (browser navigation)
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '') || 'home';
      setActiveSection(hash);
    };

    // Set initial section from URL
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    // Intersection Observer for section detection
    const sections = document.querySelectorAll('section[id]');
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -20% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveSection(sectionId);
          
          // Update URL hash without triggering scroll
          if (window.location.hash !== `#${sectionId}`) {
            window.history.replaceState(null, '', `#${sectionId}`);
          }
        }
      });
    }, observerOptions);

    // Observe all sections
    sections.forEach((section) => observer.observe(section));

    // Cleanup
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  useEffect(() => {
    // Smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  return (
    <div className="App">
      <Background />
      <Navigation activeSection={activeSection} />
      
      <div className="app-layout">
        <MainContent />
      </div>
    </div>
  );
};

export default App;
